export default {"src":"https://fishbrain.com/_next/static/media/idaho.8a1a6f24.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};